import React from 'react';

const Title = () => (
  <>
    <h1 className="firstTitle">Born In Space</h1>
  </>
);

export default Title;
